import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BudgetsPage.QBooksBudgets.NoBudgets', {
    title: 'You don’t have any Budgets',
    uploadFirstBudget: 'Upload first budget',
    or: 'or',
});
